/**
 * Experiment Registry
 *
 * Central registry mapping experiment IDs to their definitions.
 * Adding a new experiment = adding one entry here.
 *
 * Experiments are opt-in by default:
 * - No query params → defaultVariant for everyone
 * - ?experiment=<id> → random variant assignment (persisted)
 * - ?experiment=<id>&variant=<v> → explicit variant override
 */

import type { ExperimentDefinition } from './useExperimentStore';
import { BREAK_PAGE_EXPERIMENT } from './useExperimentStore';

/**
 * All registered experiments, keyed by experiment ID.
 * The router guard uses this to look up experiments from URL params.
 */
export const EXPERIMENT_REGISTRY = {
	[BREAK_PAGE_EXPERIMENT.id]: BREAK_PAGE_EXPERIMENT,
	// Add future experiments here:
	// [SOME_OTHER_EXPERIMENT.id]: SOME_OTHER_EXPERIMENT,
} as const satisfies Record<string, ExperimentDefinition>;

export type RegisteredExperimentId = keyof typeof EXPERIMENT_REGISTRY;
